<template>
  <Line
    :chart-options="chartOptions"
    :chart-data="chartData"
    :chart-id="chartId"
    :dataset-id-key="datasetIdKey"
    :css-classes="cssClasses"
    :styles="styles"
    :width="200"
    :height="myheight"
  />
</template>

<script>
import { Line } from 'vue-chartjs'

const varPercentage = [null,'14,0%', '13,5%', '13,7%', '13,6%', '18,2%', '19,6%',null];

export default {
  name: 'LineChart',
  components: { Line },
  props: {
    chartId: {
      type: String,
      default: 'line-chart'
    },
    datasetIdKey: {
      type: String,
      default: 'label'
    },
    height: {
      type: Number,
      default: 100
    },
    cssClasses: {
      default: '',
      type: String
    },
    styles: {
      type: Object,
      default: () => {}
    }
  },
  computed: {
    myheight() {
      if(window.innerWidth>1024){
        return this.height;
      } else if(window.innerWidth>768){
        return 100;
      } else {
        return 150;
      }
    }
  }
  ,
  mounted() {
    //console.log('line chart mounted');
  },
  created() {
    //console.log('line chart created');
  },
  unmounted: function() {
    //console.log('line chart destroyed');
  },
  data() {
    return {
      chartData: {
        labels: [null,"2016", "2017", "2018", "2019", "2020", "2021",null],
        datasets: [
          {
            data: [null,'14,0%', '13,5%', '13,7%', '13,6%', '18,2%', '19,6%',null],
          },
          {
            type: "line",
            label: "EBITDA",
            data: [null,239, 242, 243, 253, 306, 401,null],
            backgroundColor: 'white',
            borderColor: '#bdd3df',
            lineBorderWidth: 4,
            pointBorderWidth: 2,
            pointRadius: 5,
            pointHoverRadius: 5,
            datalabels: {
              labels: {
                index: {
                  align: 'end',
                  anchor: 'end',
                  color: 'black',
                  font: {
                    size: 16,
                    weight: "normal",
                  },
                  formatter: function(value, ctx) {
                    return ctx.active
                      ? varPercentage[ctx.dataIndex]
                      : varPercentage[ctx.dataIndex];
                  },
                  offset: 35
                },
                value: {

                }
              }
            }

          },
          {
            type: "line",
            label: "Beneficio Neto",
            data: [null,127, 83, 95, 69, 60, 179,null],
            backgroundColor: 'white',
            borderColor: '#1173b9',
            lineBorderWidth: 4,
            pointBorderWidth: 2,
            pointRadius: 5,
            pointHoverRadius: 5

          }
        ]
      },
      chartOptions: {
        //responsive: false,
        maintainAspectRatio: true,
        //categoryPercentage: 1.0,
        //barPercentage: 0.05,
        layout: {
            padding: {
              top:  40
            }
        },
        animation: {
          duration: 2000,
        },
        scales: {
          x: {
            grid: {
              display: false
            },
            ticks: {
                font: {
                    size: 16,
                    weight: 700,
                    family: '"Gotham Light", Helvetica, Arial, sans-serif'
                },
                color: '#000000'
            }
          },
          y: {
            ticks: {
                font: {
                  size: 16,
                    weight: 700,
                    family: '"Gotham Light", Helvetica, Arial, sans-serif'
                },
                color: '#000000'
            },
          }

        },

        plugins: {
            legend: {
              display: false,
            },
            datalabels: {
                  color: 'black',
                  textAlign: 'center',
                  anchor: 'end',
                  align: 'top',
                  offset: 5,
                  font: {
                      weight: "bold",
                      size: 18,
                      family: '"Gotham Light", Helvetica, Arial, sans-serif'
                  }
              },

        }
      }
    }
  }
}
</script>
